import unidad_medida_model from '@/shared/models/unidad_medida_model';

export const Moneda = {
  Codigo: 2,
  Descripcion: 'Dolar americano',
  Abreviatura: 'U$S',
  Activo: true,
};

export const MateriaPrimaFamilia = {
  Codigo: null,
  Descripcion: '',
  CodigoAdicional: null,
  Activo: true,
};

export const MaterialCategoria = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

export const MaterialTipo = {
  Codigo: null,
  Descripcion: null,
  CodigoMaterialCategoria: null,
  Activo: null,
  MaterialCategoria,
};

export const Material = {
  Codigo: null,
  CodigoMaterialTipo: null,
  DescripcionInterna: null,
  DescripcionCliente: null,
  DescripcionReporte: null,
  CodigoAdicional: null,
  Costo: null,
  CodigoMoneda: null,
  CodigoUnidadMedida: null,
  CodigoUnidadMedidaSecundaria: null,
  Exact: true,
  TiempoEntrega: null,
  CodigoProveedor: null,
  Activo: true,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  MaterialTipo,
  MateriaPrimaFamilia,
  Moneda,
  UnidadMedida: { ...unidad_medida_model },
  OrientacionFibra: 0,
  AtributosAdicionales: {},
  CodigoMaterialCategoria: null,
  RelacionFija12: false,
  CantidadUnidadesMedida: 1,
  CodigoUnidadMedidaTerciaria: null,
  FactorConversion23: null,
  RelacionFija23: null,
  CantidadMinima: 0,
  CantidadReposicion: 0,
  CantidadMaxima: 0,
  Precio: 0,
  AdministraSeries: false,
  AdministraLotes: false,
  AdministraOT: false,
  AdministraUbicaciones: false,
  UnidadMedidaSecundaria: { ...unidad_medida_model },
  UnidadMedidaTerciaria: { ...unidad_medida_model },
  Proveedor: null,
  MaterialClientes: [],
  EsGenerico: false,
};

export const initial_filters = {
  CodigoAdicional: null,
  Familias: [],
  MaterialTipos: [],
  codigosFamilia: [],
  tipos: [],
  DescripcionInterna: null,
  GenericoFiltro: null,
  filtroGenerico: null,
};
